import { Dispatch, SetStateAction } from 'react';

import {
  CreateLocationForm,
  CreatePasswordForm,
  ForgotPasswordForm,
  SetUpAccountForm,
  SignInForm,
  SignUpForm,
} from 'authOld/components';
import { IAuthUser } from 'authOld/types';
import { SwitchUserVersionProvider } from 'core/states';
import {
  Logo,
  Navigation,
  ProfileNav,
  RightNavigation,
  SearchField,
  Visible,
} from 'coreOld/components';
import { HeaderModalOptions } from 'coreOld/constants';
import { DropdownOptions } from 'coreOld/types';
import { logoHomePath } from 'home/routes/routePaths';
import { isPlainHomepageInstance } from 'home/utils';

import { HeaderWrapper, LeftNavWrapper, SearchWrapper } from './headerStyle';

interface IProps {
  user?: IAuthUser;
  isFixed?: boolean;
  hasSearchBar?: boolean;
  isSearchFocus?: boolean;
  setIsSearchFocus?: Dispatch<SetStateAction<boolean>>;
  collapsedMenu?: boolean;
  openedDropdown: DropdownOptions;
  toggleDropdown: (name: keyof DropdownOptions) => void;
  logoPath?: string;
  onNext: (step: HeaderModalOptions) => void;
}

const HeaderView = ({
  user,
  isFixed,
  hasSearchBar,
  isSearchFocus,
  setIsSearchFocus,
  collapsedMenu = false,
  openedDropdown,
  toggleDropdown,
  logoPath,
  onNext,
}: IProps) => {
  const showPlainHeaderBar = !user && isPlainHomepageInstance();

  return (
    <HeaderWrapper isFixed={isFixed}>
      <Logo url={logoHomePath()} path={logoPath} />

      {/* if collapsed menu does not show */}
      {!showPlainHeaderBar && !collapsedMenu && <Navigation user={user} />}

      {user && (
        <LeftNavWrapper>
          {!collapsedMenu && (
            <>
              <Visible when={hasSearchBar}>
                <SearchWrapper isSearchFocus={isSearchFocus}>
                  <SearchField setIsSearchFocus={setIsSearchFocus} />
                </SearchWrapper>
              </Visible>

              <RightNavigation
                user={user}
                openedDropdown={openedDropdown}
                toggleDropdown={toggleDropdown as (name: string) => void}
              />
            </>
          )}
          <SwitchUserVersionProvider>
            <ProfileNav
              user={user}
              openedDropdown={openedDropdown}
              toggleDropdown={toggleDropdown as (name: string) => void}
              collapsedMenu={collapsedMenu}
            />
          </SwitchUserVersionProvider>
        </LeftNavWrapper>
      )}

      {!user && (
        <>
          <SignInForm />

          <CreatePasswordForm onNext={onNext} />

          <SignUpForm />

          <ForgotPasswordForm />

          <SetUpAccountForm onNext={onNext} />

          <CreateLocationForm onNext={onNext} />
        </>
      )}
    </HeaderWrapper>
  );
};

export default HeaderView;
